<template>
	<el-switch v-model="transBoolean" @change="change"/>
</template>

<script>
	import { ElMessage,ElMessageBox,ElNotification} from 'element-plus';
	export default{
		props:{
			modelValue:{
				type:[Number,String],
				default:''
			}
		},
		data(){
			return{
				transBoolean:''// 0/1转换为false/true
			}
		},
        mounted(){
			if(this.modelValue==0){
				this.transBoolean=false;
			}
			if(this.modelValue==1){
				this.transBoolean=true;
			}
		},
		methods:{
			/*选择事件*/
			change(e){
				let res=e?1:0;
				this.$emit('update:modelValue',res)
				this.$emit('change',res);
			}
		}
	}
</script>

<style>
</style>